import { OrganizationType } from "@slr/user-service-external-sdk";
import { InvitationSuccessLogo } from "assets";
import {
  MARKETPLACE_URL,
  PROFILE_ORGANIZATIONS_PATH,
  PROFILE_PATH,
} from "configs";
import { useGetCurrentUserProfileWithSolution1 } from "hooks";
import { FC, useMemo } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

type SuccessProps = {
  organizationId: string;
  organizationName: string;
  organizationType: OrganizationType;
};

export const Success: FC<SuccessProps> = ({
  organizationId,
  organizationName,
  organizationType,
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "invitationsPage.success",
  });

  const { data: userProfile } = useGetCurrentUserProfileWithSolution1();

  const isBusinessAccount =
    userProfile?.billingAddress?.addressType === "business";

  const redirectUrl = useMemo(() => {
    if (organizationType === OrganizationType.SolutionProvider) {
      return MARKETPLACE_URL;
    }
    if (isBusinessAccount) {
      return `${PROFILE_ORGANIZATIONS_PATH}/${organizationId}`;
    }
    return PROFILE_PATH;
  }, [organizationType, organizationId, isBusinessAccount]);

  const buttonLabelKey = useMemo(() => {
    if (organizationType === OrganizationType.SolutionProvider) {
      return "toMarketplace";
    }
    if (isBusinessAccount) {
      return "manage";
    }
    return "toProfile";
  }, [organizationType, isBusinessAccount]);

  return (
    <>
      <Row>
        <Col>
          <p className="text-left">
            {t("description", {
              organization: organizationName,
            })}
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p className="text-left mt-4">{t("options")}</p>
        </Col>
      </Row>
      <Row>
        <Col className="text-center mt-5">
          <InvitationSuccessLogo />
        </Col>
      </Row>
      <Row>
        <Col className="text-center">
          <Link
            to={redirectUrl}
            className="mt-5 mb-4 btn btn-primary btn-lg"
            replace
          >
            {t(buttonLabelKey)}
          </Link>
        </Col>
      </Row>
    </>
  );
};
